import { render, staticRenderFns } from "./BPMap.vue?vue&type=template&id=53a4a665"
import script from "./BPMap.vue?vue&type=script&lang=js"
export * from "./BPMap.vue?vue&type=script&lang=js"
import style0 from "./BPMap.vue?vue&type=style&index=0&id=53a4a665&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports